module.exports = __webpack_public_path__ + "static/Ravenous-e1317b6579145b42c5f91753b71fd186.png";